import { hydrateRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { loadableReady } from 'sku/@loadable/component';

import { client } from 'src/modules/apollo/apolloClient';
import { initDatadogRum } from 'src/modules/datadog/datadog';
import { makeRoutes } from 'src/routes';
import type { ConfigStateContext } from 'src/types';

import logger from './modules/logger/logger';

loadableReady(async () => {
  const container = document.getElementById('app');

  if (!container) {
    throw Error('App container (#app) not found.');
  }

  const config: ConfigStateContext =
    window.__CONFIG_STATE__ as ConfigStateContext;
  client.cache.restore(window.__APOLLO_STATE__);

  logger.debug('Client-side app starting up.', config);

  const router = createBrowserRouter(
    makeRoutes({ client, config, clientOrServer: 'client' }),
  );

  if (config.environment === 'production') {
    initDatadogRum({
      environment: config.environment,
      buildVersion: '1.0.0',
    });
  }

  hydrateRoot(container, <RouterProvider router={router} />);
});
